import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/animations/loading.json';

const Loading = ({ fullScreen = true, message = "Yükleniyor..." }) => {
    const content = (
        <div className="flex flex-col items-center justify-center p-8">
            <div className="w-64 h-64 md:w-80 md:h-80">
                <Lottie
                    animationData={loadingAnimation}
                    loop={true}
                    style={{ width: '100%', height: '100%' }}
                />
            </div>
            {message && (
                <p className="mt-4 text-gray-600 dark:text-gray-300 font-semibold text-lg tracking-wide animate-pulse">
                    {message}
                </p>
            )}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 z-[9999] bg-white dark:bg-gray-900 flex items-center justify-center">
                <div className="relative">
                    {/* Arka planda hafif bir parlama efekti - Opsiyonel */}
                    <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-full scale-150"></div>
                    {content}
                </div>
            </div>
        );
    }

    return <div className="w-full h-full flex items-center justify-center">{content}</div>;
};

export default Loading;
